// distributor-form.component.ts

import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { DistributorService } from '../Services/distributor.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Distributor } from '../objects/Distributor'; 
import {DistributorMaterialService} from '../Services/distributormaterials.service';
import { MaterialsService } from '../Services/materials.service';
import { Materials } from '../../../Materials';
import { DistributorMaterial } from '../objects/DistributorMaterial';

@Component({
  selector: 'app-distributor-form',
  templateUrl: './distributor-form.component.html',
  styleUrls: ['./distributor-form.component.css'],
})
export class DistributorFormComponent implements OnInit {
  form: FormGroup;
  distributorId: number | undefined ;
  isLoadingResults: boolean | undefined; 
  showAvailbleMaterials: boolean | undefined; 

  items: any[] = [];
  materials: Materials []=[];
  distributorMaterials: DistributorMaterial []=[];
  sortProperty: string = 'id';
  sortOrder = 1;
  sortListProperty: string = 'id';
  sortListOrder = 1;
  distributorObject?: Distributor;
  

  constructor(private fb: FormBuilder,
    private api: DistributorService,
    private materialsService: MaterialsService,
    private distributorMaterialService: DistributorMaterialService,
    private router: Router,
    private route: ActivatedRoute,
    private distributorService: DistributorService) {
    this.form =  this.createFormGroup()    
 
  }
  createFormGroup()  
  {
    return new FormGroup({
      id: new FormControl(),
       name: new FormControl()}
    )

  }
  updateForm(distributor:Distributor)
  {  
    if (this.distributorId==undefined)
    {
      this.form.setValue({name: distributor.name, id: undefined});
    }
    else
    {
    this.form.setValue({name: distributor.name, id: this.distributorId});
    }
}


  ngOnInit() {
    this.route.paramMap.subscribe((params) => {
      const distributorId = parseInt(params.get('id') || '0', 10);
      if (distributorId > 0) {
        this.loadDistribtor(distributorId);

        this.distributorId = distributorId;
      }
    });
 
    this.loadMaterials();
  }

  loadMaterials() {
    this.materialsService.GetMaterials().subscribe((materials) => {
      this.materials = materials;
      console.log(materials);
      
    });
  }


  loadDistribtor(distributorId:any)
  {
    this.distributorService.getDistributor(distributorId).subscribe((distributor) => {
 
      this.distributorObject = distributor;
      
      this.distributorMaterials = distributor.distributorMaterial;
      this.updateForm(distributor)
    });
  }

  toggleAvailbleMaterials()
  {
    if(this.showAvailbleMaterials)
    {
      this.showAvailbleMaterials = false;
    }
    else
    {
      this.showAvailbleMaterials = true;
    }

  }
  onSubmit() {
   
    if (this.form.valid) {
      // Here, you can send the form data to the backend
      console.log('Form data:', this.form.value);

      //Save to Database
      let result: Distributor = Object.assign({}, this.form.value); 
       result.id = 4; 
      // let newDistributor:  Distributor | new ;
      // newDistributor.name = result.name;


   if (this.distributorId == undefined)
   { 
      this.api.addDistributor(result)
        .subscribe(res => {
           let id = res['id'];
            
            this.isLoadingResults = false;
            console.log('Distributor added successfully!');
            this.router.navigate(['/distributor-grid', id]);
          }, (err) => {
            console.log(err);
            this.isLoadingResults = false;
          });
    } 
    else
    { 
    
      this.api.editDistributor(result)
      .subscribe(res => {
         let id = res['id'];
          
          this.isLoadingResults = false;
          console.log('Distributor added successfully!');
          this.router.navigate(['/distributor-grid', id]);
        }, (err) => {
          console.log(err);
          this.isLoadingResults = false;
        });
    }
   
  }

      // After submitting the form, you can navigate to the grid or another page
      this.router.navigate(['/distributor-grid']);
    }



    sortBy(property: string) {
     
      this.sortOrder = property === this.sortProperty ? (this.sortOrder * -1) : 1;
      this.sortProperty = property;
      this.items = [...this.materials.sort((a: any, b: any) => {
          // sort comparison function
          let result = 0;
          if (a[property] < b[property]) {
              result = -1;
          }
          if (a[property] > b[property]) {
              result = 1;
          }
          return result * this.sortOrder;
      })];
  }
  
  sortIcon(property: string) {
      if (property === this.sortProperty) {
          return this.sortOrder === 1 ? '☝️' : '👇';
      }
      return '';
  }

  sortListBy(property: string) {
     
    this.sortListOrder = property === this.sortListProperty ? (this.sortListOrder * -1) : 1;
    this.sortListProperty = property;
    this.items = [...this.materials.sort((a: any, b: any) => {
        // sort comparison function
        let result = 0;
        if (a[property] < b[property]) {
            result = -1;
        }
        if (a[property] > b[property]) {
            result = 1;
        }
        return result * this.sortListOrder;
    })];
}

sortListIcon(property: string) {
    if (property === this.sortListProperty) {
        return this.sortListOrder === 1 ? '☝️' : '👇';
    }
    return '';
}
addMaterialToDistributorMaterials(material:Materials)
{
  let newDistributorMaterial: DistributorMaterial  = Object.assign(material);
  let newDistributor: Distributor   = Object.assign({}, this.distributorObject); 
  newDistributorMaterial.distributorId = newDistributor.id;
  newDistributorMaterial.materialsID = material.id;
   //console.log(this.name,this.empoloyeeID);
 
   newDistributor.distributorMaterial = newDistributor.distributorMaterial || [];
  //  if(newDistributor.distributorMaterial == null)
  // {
  //     this.distributorMaterials.fill(newDistributorMaterial);

  // }  
  newDistributor.distributorMaterial.push(newDistributorMaterial);
  

  this.distributorService.editDistributor(newDistributor)
  .subscribe(res => {
     
      
      this.isLoadingResults = false;
      console.log('Distributor edited successfully!');
      this.loadDistribtor(this.distributorObject?.id);
    }, (err) => {
      console.log(err);
      this.isLoadingResults = false;
    });
}

removeMaterialfromDistributor(material:DistributorMaterial)
{

}
addAllMaterials()
{
  for(let o of this.materials){
    this.addMaterialToDistributorMaterials(o);
 }
   
}
}
 